import type { TourStepDef } from '../types';

/** Helper to build a step on a fixed route */
export function s(
  target: string,
  titleKey: string,
  bodyKey: string,
  route: string,
  extra?: Partial<TourStepDef>
): TourStepDef {
  return {
    target,
    titleKey,
    bodyKey,
    route,
    placement: extra?.placement || 'auto',
    ...extra,
  };
}
